import React from 'react';
import AppRouter from './Router/Router';

function App() {
  return (
    <div id="App">
      <AppRouter />
    </div>
  );
}

export default App;
